import React from 'react'
import {Col, Badge, Label, Row} from 'reactstrap'
import {Link} from 'react-router-dom'
import Loader from 'react-loader-spinner'
import {ModelListTable} from '../../ui'
import {getAllControllers, WS_URL, RESPONSE_PAGE_SIZE} from '../../../api'
import Websocket from "react-websocket"

import {Controller, AppError} from "../../../models"
import {pageHelpers} from "../"
import ControllerIcon from "react-icons/lib/fa/square"
import DashboardIcon from "react-icons/lib/fa/dashboard"
import CircleIcon from 'react-icons/lib/fa/circle'
import HalfCircleIcon from 'react-icons/lib/fa/exclamation-circle'
import BrokenCircleIcon from 'react-icons/lib/fa/times-circle'
import ArchiveIcon from 'react-icons/lib/fa/archive'
import PauseIcon from 'react-icons/lib/fa/pause'
import PlayIcon from 'react-icons/lib/fa/play'
import {Paginator} from '../../ui'

import '../../../stylesheets/Search.css'

const DASHBOARD_FIELD_NAME = "-"
const STATUS_FIELD_NAME = "_"

let dashboardLinkGenerator = (controller) => {
    return <Link to={`/controllers/${controller.id}`}>
        <Badge className="p-2 bg-light-sf-blue">
            <DashboardIcon className="d-none d-md-inline-block mr-2"/>
            <span className="d-inline-block d-md-none">DASH</span>
            <span className="d-none d-md-inline-block">Dashboard</span>
        </Badge>
    </Link>
}

let statusIconForController = (controller) => {
    if (controller.archived) {
        return <ArchiveIcon className="text-muted mr-1 ml-0 mr-sm-3"/>
    } else if (controller.missedHeartbeats > 0) {
        return <HalfCircleIcon className="text-warning mr-1 ml-0 mr-sm-3"/>
    } else if (controller.online) {
        return <CircleIcon className="text-success mr-1 ml-0 mr-sm-3"/>
    } else {
        return <BrokenCircleIcon className="text-danger mr-1 ml-0 mr-sm-3"/>
    }
}

let statusTextForController = (controller) => {
    let runStatusText = (controller.running ? "Pump running" : "Pump stopped")
    let connStatusText = ""

    if (controller.archived) {
        connStatusText = "controller archived"
    } else if (controller.missedHeartbeats > 0) {
        connStatusText = "controller has intermittent connectivity"
    } else if (controller.online) {
        connStatusText = "controller online"
    } else {
        connStatusText = "controller offline"
    }

    return `${runStatusText} and ${connStatusText}`
}

let statusGenerator = (controller) => {
    return <span title={statusTextForController(controller)}>
        {statusIconForController(controller)}
        {controller.running ?
            <PlayIcon className="text-secondary"/> :
            <PauseIcon className="text-secondary"/>}
    </span>
}

class SearchPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        const {token, history} = props

        this.state = {
            token,
            loading: false,
            search: '',
            errors: [],
            contrfollers: [],
            currentControllerPage: this.queryParams.controllerPage || 1,
            totalControllers:'',
            controllerParams: ''
        }

        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.fetchControllers = this.fetchControllers.bind(this)
    }

    async componentWillReceiveProps(nextProps) {
        const {token} = nextProps
        let{currentControllerPage, search, controllerParams} = this.state
        pageHelpers.setupPropsForPage(nextProps, this)
        if (token) {
            await this.setState({token, loading: true,currentControllerPage, controllerParams, search:this.queryParams.search})
            await this.fetchControllers()
            this.setState({loading: false})
        }
        else{
            search:this.queryParams.search
        }
    }

    async componentDidMount() {
        if (this.state.token) {
            this.setState({loading: true})
            await this.fetchControllers()
            this.setState({loading: false})
        }
    }

    /* Check the url parameters,if it contains searchParam 
    and not contains controlerparam then set to 1
    */
    async fetchControllers() {
        let {token, currentControllerPage, search, controllerParams} = this.state
        try {
            let controllerParam
            let url =  window.location.search
            let urlParams = new URLSearchParams(url);
            controllerParam = urlParams.get('controllerPage')
            let searchParam = urlParams.get('search')
            if(!controllerParam ){
                controllerParam = 1 
            }
            if(searchParam == '' && controllerParam == '' ){
                controllerParam = ''
            }
            if(!searchParam){
                searchParam = ''
            }
            this.setState({search:searchParam, controllerParams:controllerParam})
            let {results, count} = await getAllControllers(token, false, true, false, false, false, false, controllerParam, RESPONSE_PAGE_SIZE, searchParam)
            this.setState({loading:true, controllers:results, totalControllers:count})
        } catch(err) {
            console.log(err)
            let appError = new AppError("Failed to Get Controllers", err.message)
            this.setState({errors:[appError]})
        }
    }

    handleWebSocketResponse(data) {
        let result = JSON.parse(data)
        let updatedController = Controller.fromAPIObject(result)
        let {controllers} = this.state
        let filteredControllers = controllers.filter((controller) => controller.id !== updatedController.id)
        let oldControllers = controllers.filter((controller) => controller.id === updatedController.id)
        if (filteredControllers.length < controllers.length && oldControllers.length) {
            let oldController = oldControllers[0]
            updatedController.team = oldController.team
            controllers = filteredControllers
            controllers.push(updatedController)
            this.setState({controllers})
        }
    }

    render() {
        let {errors, token, controllers, search, totalControllers,loading, currentControllerPage, searchParam, controllerParams} = this.state
        let fixedCharacterWidthFields = {}
        fixedCharacterWidthFields[STATUS_FIELD_NAME] = 4
        fixedCharacterWidthFields[DASHBOARD_FIELD_NAME] = [4.2, 8]
       
        let fieldContentGenerators = {}
        fieldContentGenerators[STATUS_FIELD_NAME] = statusGenerator
        fieldContentGenerators[DASHBOARD_FIELD_NAME] = dashboardLinkGenerator
        let activeBaseURL
      
        if (search) {
            activeBaseURL = `${window.location.pathname}?search=${search}&controllerPage=`;
        } else{
            activeBaseURL = `${window.location.pathname}?controllerPage=`
        }
        let count = (controllers && controllers.length ? controllers.length : 0)
        let activeCount = (controllers && controllers.length ? controllers.filter(c=>!c.archived).length : 0)
        let archivedCount = (controllers && controllers.length ? controllers.filter(c=>c.archived).length : 0)
       
        return (
            <Col xs={12} className="text-center">
                <h1 className="col-12 no-gutters mb-2 d-block d-sm-none light-sf-orange font-weight-bold p-0"><ControllerIcon
                    className="light-sf-blue mr-2"/>Search Controllers</h1>
                <h1 className="col-12 no-gutters mb-2 d-none d-sm-block light-sf-orange font-weight-bold"><ControllerIcon
                    className="light-sf-blue mr-2"/>Search Marksman Controllers</h1>
                <p className="col-12 mb-4">
                    <Link className="light-sf-blue" to="/management/controllers/provision">or provision a new controller</Link>
                </p>

                {count && !loading ?
                    <Label className="small text-secondary col-12 text-left">
                        {count} Controllers &mdash; {activeCount} Active &mdash; {archivedCount} Archived
                    </Label>:
                        null}

                {loading ?
                    <Col xs={12} className="text-center m-4">
                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                    </Col> :
                    <ModelListTable models={controllers}
                                    fields={[STATUS_FIELD_NAME, "serialNumber", "name", "teamName", "iccid", DASHBOARD_FIELD_NAME]}
                                    searchFields={["serialNumber", "name", "teamName", "iccid"]}
                                    searchParam = {search}
                                    boldFields={["serialNumber"]}
                                    hideableFields={["teamName", "name", STATUS_FIELD_NAME]}
                                    leftAlignFields={["serialNumber", "name", "teamName"]}
                                    fixedCharacterWidthFields={fixedCharacterWidthFields}
                                    fieldContentGenerators={fieldContentGenerators}
                                    className="p-0"/>}
                                    <br></br>
                    {Math.ceil(count / RESPONSE_PAGE_SIZE) >=1 ?
                        <Row className="justify-content-center">
                            <Paginator
                                key={`paginator-${totalControllers}-${controllerParams}-${RESPONSE_PAGE_SIZE}`}
                                count={totalControllers}
                                pageSize={RESPONSE_PAGE_SIZE}
                                currentPage={controllerParams}
                                baseURL={activeBaseURL}/>
                        </Row> :
                        null}

                {pageHelpers.renderErrorModalsForPage(errors, this)}
            </Col>)
    }
}

export default SearchPage



// WEBPACK FOOTER //
// ./src/components/pages/controllers/SearchPage.js